export const actionTypes: any = {
  // update
  UPDATE_PASSWORD_START: 'UPDATE_PASSWORD_START',
  UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FINISH: 'UPDATE_PASSWORD_FINISH',
  UPDATE_PASSWORD_RESET: 'UPDATE_PASSWORD_RESET',
}
